import styled from "styled-components/macro";
import { makeStyles } from "@mui/styles";
import { md } from "../../styles/responsive";
// import banner002 from "../../assets/images/banner002.png";

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const CarouselIMG = styled.img`
  width: 100%;
  display: flex;
`;

export const Span = styled.div`
  color: #000;
  background: #fff;
  border-radius: 4px;
  padding: 0.6rem 0.4rem;

  @media screen and (min-width: 992px) {
    font-size: 1rem;
    padding: 0.6rem 0.4rem;
  }
`;

export const SpanDot = styled.div`
  color: #000;
  font-weight: 700;
  padding: 0.6rem;
  font-size: 1rem;
  display: block;
  /* margin: 0 .4rem; */
  /* line-height: 1.5; */

  @media screen and (min-width: 992px) {
    font-size: 1rem;
    /* padding: .8rem; */
    margin: 0 0.1rem;
    padding: 0.6rem;
  }
`;

export const FlexDate = styled.div`
  display: flex;
  line-height: 1.5;
  padding: 0 0.4rem;
  width: 100%;
  margin-bottom: 1rem;
  justify-content: center;

  @media screen and (min-width: 768px) {
    padding: 0.2rem;
    width: 100%;
  }

  @media screen and (min-width: 992px) {
    padding: 0.2rem;
    width: auto;
  }
`;

const config = {
  theFontTitle: {
    fontSize: "34px",
    ...md("sm", {
      fontSize: "34px",
    }),
    ...md("md", {
      fontSize: "54px",
    }),
    ...md("lg", {
      fontSize: "64px",
    }),
  },

  theFont: {
    fontSize: "14px",
    ...md("md", {
      fontSize: "14px",
      textAlign: "justify",
    }),

    ...md("lg", {
      fontSize: "14px",
      textAlign: "justify",
    }),
  },

  theFont_: {
    fontSize: "14px",
    ...md("md", {
      fontSize: "14px",
      width: "60%",
    }),

    ...md("xmd", {
      fontSize: "14px",
      width: "50%",
    }),

    ...md("lg", {
      fontSize: "14px",
      width: "55%",
    }),
  },

  theHeadTitle: {
    color: "#FFF !important",
  },

  theCardWarehouse: {
    background: "#AC5500",
    padding: "1rem",
    borderRadius: "6px",
  },

  theCardUser: {
    background: "#FF9200",
    padding: "1rem",
    borderRadius: "6px",
  }
};

export default makeStyles(config);
